<template>
  <article class="card listing">
    <a class="card-link" :href="toUrl" target="_blank">
      <figure>
        <img :src="imgUrl" :alt="imgAltText" />
      </figure>
      <p v-if="tag" class="article-topic">{{ tag }}</p>
      <section>
        <h3 class="heading">{{ heading }}</h3>
        <p v-if="content">{{ content }}</p>
        <time v-if="date" :datetime="toDate">{{ displayDate }}</time>
      </section>
      <p class="button crimson no-hover-focus">Read more</p>
    </a>
  </article>
</template>

<script>
import { formatDate } from '@general/js/utils/dateTimeUtils';

export default {
  name: 'Card',

  props: {
    heading: {
      type: String,
      required: true,
    },
    content: {
      type: String,
    },
    imgUrl: {
      type: String,
      required: true,
    },
    toUrl: {
      type: String,
      required: true,
    },
    imgAltText: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
    },
    date: {
      type: String,
    },
  },

  computed: {
    toDate() {
      return formatDate(new Date(this.date));
    },

    displayDate() {
      // this will return as DD Month YYYY
      return new Intl.DateTimeFormat('en-GB', { dateStyle: 'long' }).format(new Date(this.date));
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  margin-bottom: 0;
}

// Override anchor style defined in app.vue
#member-portal a.card-link {
  display: flex;
}
</style>
